import {createRef} from "../createRef";

export default createRef({
    "id": "STRUCTURE_REF",
    "source": "STRUCTURE_REF",
    "fields": [
        {   "column": "code", },
        {   "column": "name", },
    ],
});
